import { ENVS } from '../../../lib/env'

export const FEATURE_ENABLE_CONTROL_ON_DISCOUNT = 'enable_control_on_discount'
export const FEATURE_ENABLE_REGISTER_ACCESS_CONTROL =
  'enable_register_access_control'
export const REACT_PRODUCT_SEARCH_FIX = 'react_product_search_fix'
export const REACT_SUMMARY_PANEL = 'react_summary_panel'
export const REACT_PAYMENT_PANEL = 'react_payment_panel'
export const REACT_CONFIRMATION_PANEL = 'react_confirmation_panel'
export const REACT_SALE_COMPONENT = 'react_sale_component'
export const REACT_REGISTER_OPEN_CLOSE = 'react_register_open_close'
export const FEATURE_DEPRECATE_VD_ACTIVE_USER = 'deprecate_vd_active_user'
export const FEATURE_ROUND_TO_2DP_BEFORE_SENDING = 'round_to_2dp_before_sending'
export const CASH_COUNTING_FEATURE = 'LRX-17655-cash-counting'
export const LINE_ITEM_CONSOLIDATION = 'LRX_26225_line_item_consolidation'
export const LINE_ITEM_SPLITTING = 'LRX_26225_line_item_splitting'
export const WORKFLOWS_SALE_LINE_ITEMS_SPLIT =
  'LRX_26225_workflows_sale_line_items_split'
export const FEATURE_CAPTURE_ADDRESS_SELL_SCREEN =
  'LRX-27619-capture-address-sell-screen'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS =
  'invoicing_payment_requests'
export const FEATURE_CAPTURE_ADDRESS_SELL_SCREEN_PHASE_2 =
  'LRX-27619-capture-address-sell-screen-v2'
export const LRX_30788_OUT_OF_STOCK_FLOW = 'LRX-30788_out_of_stock_flow'
export const LRX_32073_FIX_FAILURE_PROCESS = 'LRX-32073_Fix_Failure_process'
export const BLOCK_CONCURRENT_PAYMENT_ATTEMPTS =
  'block_concurrent_payment_attempts'
export const LRX_33175_FIX_BUG = 'LRX-33175_fix_bug'

/**
 * Constants related to the feature flags in use within web register.
 *
 * This is a map of feature name to default value (per environment).
 *
 * Only specify features that are currently in use.
 * Always specify a sensible default value for the production environment.
 * Specify a sensible override for test/development environments if applicable.
 * Clean up features from here when they are no longer needed.
 *
 * @module webregister.constants.WR_FEATURES
 */
export const WR_FEATURES = {
  // Declare the default fallback value of each feature for production environments here
  [ENVS.PRODUCTION]: {
    // Feature flags based on retailer subscription plan
    gift_receipts: false,
    [FEATURE_ROUND_TO_2DP_BEFORE_SENDING]: false,
    promotions: false,
    promotions_advanced: false,
    customer_groups: true,
    // Selective features: These features cannot be rolled out 100% but can
    // only be enabled per retailer
    cash_discounting: false,
    // If you don't specify your feature flag here, it wont be requested in production and so will always be false
    cardholder_data_validation_webregister: false,
    direct_econduit: false,
    parked_sales_from_read_api: false,
    payment_type_controls: false,
    terminal_tipping: false,
    lspay_customer_facing_display_enabled: false,
    lspay_cnp_payments: false,
    lspay_international_unreferenced_refunds: false,
    lspay_payment_links: false,
    lspay_pay_with_server_driven: false,
    lspay_refund_with_server_driven: false,
    lspay_referenced_refund_with_server_driven: false,
    lspay_pay_with_quick_pay_experiment: false,
    lspay_server_driven_override: false,
    lspay_surcharge: false,
    lspay_surcharge_xero_onaccount: false,
    lspay_surcharge_qbo_onaccount: false,
    lspay_tipping_on_pre_tax_amount: false,
    raise_lspay_button_on_payment_screen_experiment: false,
    lspay_unreferenced_refund: false,
    lspay_simulated_reader: false,
    lspay_eseries_refunds_on_xseries: false,
    swiper_sandbox_lspay: false,
    enable_on_account_limit_enforcement: false,
    sales_person_attribution: false,
    fulfill_from_another_outlet: false,
    has_qbo: false,
    pufs_ignore_accounting_integrations: false,
    react_workflows: false,
    custom_fields_on_receipt: false,
    payment_integration_origin_validation: false,
    create_new_sale_after_validating: false,
    validate_new_sale: false,
    use_create_sale_endpoint: false,
    limit_product_images_in_webregister: false,
    register_closure_reminder_A: false,
    register_closure_reminder_B: false,
    register_closure_reminder_lspay: false,
    auxiliary_lspay_active_pli: false,
    enable_service_orders: false,
    register_online_only_customers_webregister: false,
    register_remove_local_customer_data_webregister: false,
    swiper_check_payment_type_available_jit: false,
    price_book_subsets: false,
    webregister_react_select_register: false,
    [FEATURE_ENABLE_CONTROL_ON_DISCOUNT]: false,
    increase_variant_limit: false,
    [FEATURE_ENABLE_REGISTER_ACCESS_CONTROL]: false,
    // Disables Transifex translations from being fetched
    disable_translation: false,
    new_user_switching_in_app: false,
    enable_permission_park_sale_check: false,
    fulfillment_lif: false,
    fulfillment_lif_b3: false,
    fulfillment_lif_bug_fixes: false,
    omni_gift_cards: false,
    omni_gift_cards_allow_short_codes: false,
    [REACT_PRODUCT_SEARCH_FIX]: true,
    [FEATURE_DEPRECATE_VD_ACTIVE_USER]: false,
    [REACT_SALE_COMPONENT]: false,
    [REACT_SUMMARY_PANEL]: false,
    [REACT_PAYMENT_PANEL]: false,
    [REACT_CONFIRMATION_PANEL]: false,
    [REACT_REGISTER_OPEN_CLOSE]: true,
    react_gift_card_modals: false,
    [CASH_COUNTING_FEATURE]: false,
    track_offline_sale_metadata: false,
    [LINE_ITEM_CONSOLIDATION]: false,
    [LINE_ITEM_SPLITTING]: false,
    [FEATURE_CAPTURE_ADDRESS_SELL_SCREEN]: false,
    [WORKFLOWS_SALE_LINE_ITEMS_SPLIT]: false,
    enable_customer_saved_cards: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS]: false,
    [FEATURE_CAPTURE_ADDRESS_SELL_SCREEN_PHASE_2]: false,
    [LRX_32073_FIX_FAILURE_PROCESS]: false,
    [LRX_30788_OUT_OF_STOCK_FLOW]: false,
    [BLOCK_CONCURRENT_PAYMENT_ATTEMPTS]: false,
    [LRX_33175_FIX_BUG]: false,
  },
  // Declare test environment overrides here
  [ENVS.TEST]: {
    promotions: true,
  },
  // Declare development environment overrides here
  [ENVS.DEVELOPMENT]: {
    cardholder_data_validation_webregister: false,
    cash_discounting: false,
    dark_mode: false,
    promotions_advanced: false,
    terminal_tipping: true,
    parked_sales_from_read_api: true,
    payment_type_controls: false,
    customer_groups: true,
    fulfill_from_another_outlet: true,
    has_qbo: false,
    pufs_ignore_accounting_integrations: false,
    react_workflows: true,
    custom_fields_on_receipt: true,
    payment_integration_origin_validation: true,
    create_new_sale_after_validating: true,
    validate_new_sale: true,
    enable_on_account_limit_enforcement: true,
    use_create_sale_endpoint: true,
    limit_product_images_in_webregister: true,
    [FEATURE_ROUND_TO_2DP_BEFORE_SENDING]: false,
    register_closure_reminder_A: false,
    register_closure_reminder_B: false,
    register_closure_reminder_lspay: true,
    auxiliary_lspay_active_pli: false,
    lspay_customer_facing_display_enabled: false,
    lspay_payment_links: false,
    lspay_pay_with_server_driven: false,
    lspay_refund_with_server_driven: false,
    lspay_referenced_refund_with_server_driven: false,
    lspay_server_driven_override: false,
    lspay_surcharge: false,
    lspay_surcharge_xero_onaccount: false,
    lspay_surcharge_qbo_onaccount: false,
    lspay_pay_with_quick_pay_experiment: false,
    lspay_tipping_on_pre_tax_amount: false,
    raise_lspay_button_on_payment_screen_experiment: false,
    sales_person_attribution: true,
    enable_service_orders: true,
    register_online_only_customers_webregister: false,
    register_remove_local_customer_data_webregister: false,
    swiper_check_payment_type_available_jit: false,
    webregister_react_select_register: true,
    [FEATURE_ENABLE_CONTROL_ON_DISCOUNT]: false, // false for now, we don't want to change behavior for all devs yet
    increase_variant_limit: false,
    [FEATURE_ENABLE_REGISTER_ACCESS_CONTROL]: false,
    disable_translation: false,
    new_user_switching_in_app: false,
    enable_permission_park_sale_check: true,
    fulfillment_lif: false,
    fulfillment_lif_b3: false,
    fulfillment_lif_bug_fixes: false,
    omni_gift_cards: false,
    omni_gift_cards_allow_short_codes: false,
    frontend_metrics: false,
    [CASH_COUNTING_FEATURE]: false,
    track_offline_sale_metadata: false,
    [LINE_ITEM_CONSOLIDATION]: false,
    [LINE_ITEM_SPLITTING]: false,
    [FEATURE_CAPTURE_ADDRESS_SELL_SCREEN]: true,
    [WORKFLOWS_SALE_LINE_ITEMS_SPLIT]: false,
    enable_customer_saved_cards: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS]: true,
    [FEATURE_CAPTURE_ADDRESS_SELL_SCREEN_PHASE_2]: true,
    [LRX_32073_FIX_FAILURE_PROCESS]: false,
    [LRX_30788_OUT_OF_STOCK_FLOW]: false,
    [BLOCK_CONCURRENT_PAYMENT_ATTEMPTS]: false,
    [LRX_33175_FIX_BUG]: false,
  },
}
